import { Operator } from './operator';

export class GreaterThanInclusive implements Operator {
	public evaluate(value: number, target: number): boolean {
		return value >= target;
	}
}
